'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = require('react');
var styled = _interopDefault(require('styled-components'));
var nthHookTheme = require('@narvar/nth-hook-theme');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var StyledDivider = styled.hr.withConfig({
  componentId: "sheq9r-0"
})(function (_ref) {
  var s = _ref.s;
  return _objectSpread({
    border: '1px solid #e0e0e0',
    borderTop: 'none',
    borderRight: 'none',
    borderLeft: 'none'
  }, s);
});
var Divider = function Divider() {
  var _useTheme = nthHookTheme.useTheme(),
    dividerStyle = _useTheme.dividerPrimaryNone;
  return /*#__PURE__*/React.createElement(StyledDivider, {
    s: dividerStyle
  });
};
var index = nthHookTheme.withThemeProvider(Divider, {
  themeTokens: ['dividerPrimaryNone']
});

exports.default = index;
